<template>
  <v-layout justify-center>
    <div v-if="isCommChair">
      <v-flex xs12>
        <v-layout v-if="isCommChair">
          <v-flex xm12 sm4 class="title text-xs-center text-sm-left align-center">
            <v-select
              :items="searchSelect"
              v-model="searchType"
              label="Year"
              small
              solo
              outline
              @change="searchYear"
            ></v-select>
          </v-flex>
          <v-flex xm12 md4 class="text-sm-center">
            <span class="headline">Sponsor</span><br />
          </v-flex>
          <v-flex xm12 sm4 class="title text-xs-center text-sm-left align-center">
            <v-select
              :items="getPage"
              v-model="currentPage"
              label="Page"
              small
              solo
              outline
              @change="getCurrentPage"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>

      <List
        v-if="isList"
        :visible="isList"
        :currentYear="currentYear"
      />

      <ItemList
        v-if="isItemList"
        :visible="isItemList"
        :currentYear="currentYear"
      />

      <Accounting
        v-if="isAccounting"
        :visible="isAccounting"
        :currentYear="currentYear"
      />

      <Reports
        v-if="isReports"
        :visible="isReports"
        :currentYear="currentYear"
        @close="closeThis"
      />

      <Settings
        v-if="isSettings"
        :visible="isSettings"
      />
    </div>
    <div v-else>You Do not have access to this!</div>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import List from './List.vue'
import ItemList from './ItemList.vue'
import Accounting from './Accounting.vue'
import Settings from './Settings.vue'
import Reports from './Reports.vue'

export default {
  components: {
    List,
    ItemList,
    Accounting,
    Reports,
    Settings
  },
  data () {
    return {
      valid: true,
      myId: this.$store.state.user.id,
      page: 'Sponsor Page',
      currentPage: 'List',
      getPage: ['List', 'Item List', 'Accounting', 'Reports', 'Settings'],
      currentYear: 0,
      searchSelect: [],
      searchType: '',
      isAdmin: this.$store.state.isAdmin,
      isCommChair: false,
      isList: true,
      isBooth: false,
      isMap: false,
      isAccounting: false,
      isReports: false,
      isItemList: false,
      isSettings: false
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear
    this.searchType = this.$store.state.currentYear
    this.yearList()

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getMembers()
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    yearList () {
      for (let i = this.$store.state.currentYear; i >= 2013; i--) {
        this.searchSelect.push(i)
      }
    },

    searchYear () {
      this.currentYear = this.searchType
    },

    getCurrentPage () {
      this.isList = false
      this.isItemList = false
      this.isAccounting = false
      this.isReports = false
      this.isSettings = false

      if (this.currentPage === 'List') {
        this.isList = true
      }

      if (this.currentPage === 'Item List') {
        this.isItemList = true
      }

      if (this.currentPage === 'Accounting') {
        this.isAccounting = true
      }

      if (this.currentPage === 'Reports') {
        this.isReports = true
      }

      if (this.currentPage === 'Settings') {
        this.isSettings = true
      }
    },

    async getMembers () {
      try {
        this.isCommChair = this.isAdmin
        let item = {}
        let control = {}

        const controls = this.$store.state.controls
        control = controls.find(item => item === 'Sponsor')

        if (control) {
          this.isCommChair = true
        } else {
          const response = await Api().get('get_committee_by_code/SPC/' + this.currentYear)
          this.memberList = response.data.committee.Users

          item = this.memberList.find(item => item.id === this.myId)

          if (item.UserCommittee.title === 'Chair' || item.UserCommittee.title === 'Assist Chair') {
            this.isCommChair = true
          }
        }
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    handleResize () {
      const height = window.innerHeight - 300
      this.height = height + 'px'
    },

    closeThis () {
      this.isReports = false
      this.currentPage = 'List'
      this.getCurrentPage()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/sponsor/Enter.vue